import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import AccountTable from './AccountTable';

const Accounts = () => {
  return (
    <div className="flex min-h-screen text-white" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Right Panel */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header title="Accounts" dropdown={2} />

        {/* Main Content */}
        <Card className="flex-1 h-full" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <AccountTable />
        </Card>
      </div>
    </div>
  );
};

export default Accounts;
